import { useState, useCallback } from "react";
import { AttachmentsViewProps } from "..";

export default function useRenameEntry({
  batchEntryOps,
  setSelected,
  onError,
}: Pick<AttachmentsViewProps, "batchEntryOps" | "setSelected" | "onError">) {
  const [showRename, setShowRename] = useState("");

  const openRename = useCallback((arg: string) => setShowRename(arg), []);
  const closeRename = useCallback(() => setShowRename(""), []);
  const onRename = useCallback(
    async (
      arg: Parameters<
        NonNullable<typeof batchEntryOps>
      >[0]["entryMoves"][number],
      oldName: string,
    ) => {
      if (!arg.name || arg.name === oldName || !batchEntryOps) {
        return closeRename();
      }

      try {
        await batchEntryOps({
          entryMoves: [arg],
          entryDeletes: [],
        });

        if (setSelected) {
          setSelected((s) => {
            const selectedItemId = s.findIndex((el) => el.guid === arg.entryId);

            if (selectedItemId < 0) {
              return s;
            }

            return [
              ...s.slice(0, selectedItemId),
              { ...s[selectedItemId], name: arg.name! },
              ...s.slice(selectedItemId + 1),
            ];
          });
        }
      } catch (error) {
        console.error(error);
        if (onError) {
          onError(error as string | Error);
        }
      } finally {
        closeRename();
      }
    },
    [batchEntryOps, closeRename, setSelected, onError],
  );

  return { showRename, openRename, closeRename, onRename };
}
